import { Component, inject } from '@angular/core';
import { ButtonComponent, DialogService } from '@group24ag/flowkit';
import { DialogNewTaskComponent } from './dialog-new-task.component';
import { DialogConfirmDeleteComponent } from './dialog-confirm-delete.component';
import { DialogEditProfileComponent } from './dialog-edit-profile.component';

@Component({
  selector: 'app-ui-dialogs',
  imports: [ButtonComponent],
  template: `
    <div>
      <h1 class="heading-title">Dialog</h1>
      <div class="flex flex-col gap-5">
        <div class="flex gap-3">
          <button flkButton (click)="openNewTask()">New Task</button>
          <button
            flkButton
            [appearance]="'secondary'"
            (click)="openConfirmDelete()">
            Confirm Delete
          </button>
          <button flkButton [appearance]="'ghost'" (click)="openEditProfile()">
            Edit Profile
          </button>
        </div>
      </div>
    </div>
  `,
})
export class UIDialogsComponent {
  /** INJECTIONS **/
  /****/
  private readonly dialogService = inject(DialogService);

  /** Basic dialog — flk-input + flk-select + flk-search-select, title updates as user types */
  protected openNewTask(): void {
    this.dialogService.open(DialogNewTaskComponent, {
      title: 'New Task',
      disableClose: true,
      width: '80%',
      maxWidth: '2000px',
    });
  }

  /** disableClose + hideClose — only closeable via action buttons */
  protected openConfirmDelete(): void {
    this.dialogService.open(DialogConfirmDeleteComponent, {
      title: 'Delete Item',
      disableClose: true,
      hideClose: true,
      width: '480px',
      data: { itemName: 'Process Definition v2.4' },
    });
  }

  /** Custom size + updateSize() — "Expand" button inside widens the panel */
  protected openEditProfile(): void {
    this.dialogService.open(DialogEditProfileComponent, {
      title: 'Edit Profile',
      width: '620px',
      data: {
        firstName: 'Alice',
        lastName: 'Müller',
        email: 'alice@example.com',
        department: 'Engineering',
      },
    });
  }
}
